import { motion } from "framer-motion";
import { Wordmark } from "./Logo";
import { Lock } from "lucide-react";

const links = [
  ["Features", "#features"],
  ["Leaks", "#leaks"],
  ["Ideas", "#ideas"],
  ["Updates", "#updates"],
];

export const Nav = () => (
  <motion.header
    initial={{ y: -40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
    className="fixed inset-x-0 top-0 z-50 px-3 sm:px-6 pt-3 sm:pt-4"
  >
    <nav className="mx-auto flex max-w-6xl items-center justify-between rounded-full border border-cyan-400/20 bg-[#0A101D]/80 px-4 sm:px-6 py-2.5 backdrop-blur-xl">
      <a href="#top" data-testid="nav-logo-link"><Wordmark /></a>
      <div className="hidden md:flex items-center gap-8">
        {links.map(([l, h]) => (
          <a key={l} href={h} data-testid={`nav-link-${l.toLowerCase()}`}
            className="font-mono text-xs uppercase tracking-[0.2em] text-slate-300 hover:text-[#00E5FF] transition-colors">
            {l}
          </a>
        ))}
      </div>
      <div className="flex items-center gap-2">
      <a href="/admin" data-testid="nav-admin-link" aria-label="Admin" title="Admin"
        className="grid h-9 w-9 place-items-center rounded-full border border-cyan-400/20 text-slate-300 hover:text-[#00E5FF] hover:border-cyan-400/60 transition-colors">
        <Lock className="h-4 w-4" />
      </a>
      <a href="#download" data-testid="nav-download-button"
        className="whitespace-nowrap rounded-full bg-[#00E5FF] px-3.5 sm:px-5 py-2 font-mono text-[11px] sm:text-xs font-bold uppercase tracking-[0.15em] text-[#050911] hover:bg-white transition-colors">
        Get the app
      </a>
      </div>
    </nav>
  </motion.header>
);
